
import axios from "axios";
import {apiUrl} from '../AxiosAPI' ;  

  
// Create Course Name API post call with rest endpoint 
export const getAppsByAdminId = (appData) => axios.post(`${apiUrl}/getAppsByAdminId`,appData);  
// Create Course Name API post call with rest endpoint 
export const getAllBusinessTypes = (appData) => axios.get(`${apiUrl}/getAllBusinessTypes`,appData);  
export const getCoursesByAppToken = (appData) => axios.post(`${apiUrl}/getCoursesByAppToken`,appData);  
export const createSettingsCategories = (appData) => axios.post(`${apiUrl}/createSettingsCategories`,appData);  
export const appDesignSettings = (appData) => axios.post(`${apiUrl}/appDesignSettings`,appData);  
export const createNewApp = (appData) => axios.post(`${apiUrl}/createNewApp`,appData);  
export const getAllProductsByApp = (appData) => axios.post(`${apiUrl}/getAllProductsByApp`,appData);  
export const createRazorpayLinkedAccTempEntry = (appData) => axios.post(`${apiUrl}/createRazorpayLinkedAccTempEntry`,appData);  
export const createNewPageCMRest = (appData) => axios.post(`${apiUrl}/createNewPageCMRest`,appData);  
 
export const createNewSectionCMRest = (appData) => axios.post(`${apiUrl}/createNewSectionCMRest`,appData);  
 
export const createNewSectionTemplateCMRest = (appData) => axios.post(`${apiUrl}/createNewSectionTemplateCMRest`,appData);  
 


